var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1912_828)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 0.326174C9.09787 0.323602 11.6804 2.91132 11.6804 6.00303C11.6804 9.09732 9.09787 11.6773 6.00016 11.6756C5.1861 11.676 4.38143 11.5018 3.64044 11.1647L0.829014 11.673C0.754385 11.6867 0.677466 11.6803 0.606115 11.6545C0.534764 11.6287 0.471539 11.5844 0.422899 11.5262C0.37426 11.468 0.34195 11.3979 0.32927 11.3231C0.31659 11.2483 0.323995 11.1715 0.350729 11.1005L1.15644 8.95932C0.613626 8.06838 0.326016 7.04544 0.325014 6.00217C0.325871 2.91046 2.90587 0.327888 6.00016 0.326174ZM8.85016 8.41417C8.21844 8.92503 7.24044 9.44103 6.3053 8.84103C5.07959 8.05332 3.99444 7.01875 3.20759 5.79217C2.74559 5.07389 3.18016 3.9236 3.82987 3.22246C4.08873 2.94217 4.51559 2.98675 4.79759 3.24389L5.39073 3.7856C5.57073 3.95017 5.57759 4.23646 5.4653 4.45417C5.28787 4.79532 5.1833 5.25389 5.40273 5.59589C5.67873 6.02446 6.01816 6.44703 6.82901 6.69303C7.07416 6.76846 7.38873 6.73589 7.65616 6.62789C7.87987 6.53703 8.16359 6.53789 8.32901 6.71446L8.88101 7.3016C9.1853 7.6256 9.19559 8.13475 8.85016 8.41417Z",
    fill: "#4C9E4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1912_828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.ed35ed735712293c71c2dea9c039e14e.svg";
export { ForwardRef as ReactComponent };